import OnlineAppComponent from "../lib/online_app_component";

const AuxShadowConfig = {
    baseHtmlClass: 'online_app__aux_shadow'
}

export class AuxShadow extends OnlineAppComponent {

    constructor(onlineAppAux) {
        super(null, onlineAppAux.onlineApp, AuxShadowConfig);
        this.onlineAppAux = onlineAppAux;
        this.element = AuxShadow.createElement(AuxShadowConfig.baseHtmlClass);
    }

}
